import { render, staticRenderFns } from "./idr.vue?vue&type=template&id=19082e4c&"
import script from "./idr.vue?vue&type=script&lang=ts&"
export * from "./idr.vue?vue&type=script&lang=ts&"
import style0 from "./idr.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports